export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_UI_FORMAT = 'DD/MM/YYYY';
export const DATE_API_FORMAT = 'YYYY-MM-DD';
export const DATE_UI_FULL_MONTH_FORMAT = 'DD MMMM YYYY';
